import * as actionTypes from "./action-types";

export const setHomeOperativaState = (homeOperativaState) => {
    
    return {
        type: actionTypes.SET_HOME_OPERATIVA_STATE,
        ...homeOperativaState
    }
}